import "@/App.css";
import { BrowserRouter, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AuthCallback from "@/pages/AuthCallback";
import Home from "@/pages/Home";
import SharedPackingList from "@/pages/SharedPackingList";
import SharedItinerary from "@/pages/SharedItinerary";
import LegalPage from "@/pages/LegalPage";
import { Toaster } from "@/components/ui/sonner";
import { Compass } from "lucide-react";

function AppRouter() {
  const location = useLocation();
  const { loading } = useAuth();
  const sharedPacking = location.pathname.match(/^\/shared\/packing\/([^/]+)\/?$/);
  const sharedItinerary = location.pathname.match(/^\/shared\/itinerary\/([^/]+)\/?$/);

  if (sharedItinerary) {
    return <SharedItinerary token={sharedItinerary[1]} />;
  }

  if (sharedPacking) {
    return <SharedPackingList token={sharedPacking[1]} />;
  }

  if (/^\/privacy\/?$/.test(location.pathname)) return <LegalPage kind="privacy" />;
  if (/^\/terms\/?$/.test(location.pathname)) return <LegalPage kind="terms" />;

  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  if (loading) return <div data-testid="account-loading" className="grid min-h-screen place-items-center bg-stone-50"><Compass aria-label="Opening Pikyourtrip" className="h-7 w-7 animate-spin text-ac" /></div>;
  return <Home />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
